import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const headingVariants = cva("tracking-tight", {
  variants: {
    level: {
      1: "text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.02]",
      2: "text-3xl sm:text-4xl font-bold leading-[1.08]",
      3: "text-2xl sm:text-3xl font-semibold leading-[1.12]",
      4: "text-xl sm:text-2xl font-semibold leading-[1.16]",
    },
    serif: {
      true: "font-serif",
      false: "",
    },
  },
  defaultVariants: {
    level: 2,
    serif: false,
  },
})

type HeadingTag = "h1" | "h2" | "h3" | "h4"

interface HeadingProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof headingVariants> {
  level?: 1 | 2 | 3 | 4
  serif?: boolean
  as?: HeadingTag
}

function Heading({ level = 2, serif, as, className, ...props }: HeadingProps) {
  // Serif defaults to true for h2 section headings, false for others
  const resolvedSerif = serif ?? (level === 2)
  const Tag = (as ?? `h${level}`) as HeadingTag
  return (
    <Tag className={cn(headingVariants({ level, serif: resolvedSerif }), className)} {...props} />
  )
}

export { Heading, headingVariants }
